/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Tab_TopInputs */

const en_directory_home_board_tab_top = /** @type {(inputs: Directory_Home_Board_Tab_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top`)
};

const zh_directory_home_board_tab_top = /** @type {(inputs: Directory_Home_Board_Tab_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门`)
};

/**
* | output |
* | --- |
* | "Top" |
*
* @param {Directory_Home_Board_Tab_TopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_tab_top = /** @type {((inputs?: Directory_Home_Board_Tab_TopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Tab_TopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_tab_top(inputs)
	return zh_directory_home_board_tab_top(inputs)
});
export { directory_home_board_tab_top as "directory.home.board.tab_top" }